import { Component } from 'react'
import PropTypes from 'prop-types'
import { map, sortBy } from 'lodash-es'
import { AbilityContext } from '../../../can'
import defineAbilityFor from '../../../ability'
import TimetoastPropTypes from '../../../constants/timetoast_prop_types'
import TimelineGridItem from './timeline_grid_item'

export default class TimelineGrid extends Component {
  static propTypes = {
    currentUser: TimetoastPropTypes.currentUser,
    timelines: PropTypes.object.isRequired,
    gridItems: PropTypes.array.isRequired,
    photos: PropTypes.object.isRequired,
  }

  static defaultProps = {
    timelines: {},
    gridItems: [],
    photos: {},
  }

  render() {
    const { currentUser, gridItems, timelines, photos } = this.props

    const ability = defineAbilityFor(currentUser)
    let content
    if (gridItems.length > 0) {
      let items = sortBy(gridItems, item => new Date(item.updated_at)).reverse()
      items = map(items, item => {
        const timelineIdString = item.timeline.toString()
        const timeline = timelines[timelineIdString]
        let photo = null
        if (timeline.photo_ids.length > 0) {
          const photoIdString = timeline.photo_ids[0].toString()
          photo = photos[photoIdString]
        }
        return <TimelineGridItem key={`grid-item-${item.id}`} item={item} timeline={timeline} photo={photo} />
      })
      content = <AbilityContext.Provider value={ability}>{items}</AbilityContext.Provider>
    } else {
      content = (
        <div className="listing__no-items">
          <p>No timelines.</p>
        </div>
      )
    }

    return <section className="listing listing--grid-enabled">{content}</section>
  }
}
